var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',_vm._l((_vm.session.speakers),function(speaker,idx){return _c('speaker-side-bar',{key:idx,attrs:{"speaker":speaker}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }